import store from '@/store'

export default [
  {
    path: '/admin/dealer-profiles',
    name: 'dealer-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/dealer-profile')
  },
  {
    path: '/admin/dealer-profiles/create',
    name: 'dealer-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/dealer-profile/create.vue')
  },
  {
    path: '/admin/dealer-profiles/:id/edit',
    name: 'dealer-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/dealer-profile/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('administrator/dealerProfile/find', to.params.id)
      next()
    }
  }
]
